const Desc = `smartObjectV2: external psd input file, replace external jpeg image. ${new Error('To get file path').stack.split('\n')[1].match(/Object(.+)\(https/)[1] || ''}`

const Payload = {
    inputs: [
        {
            href: 'https://skycity-asset.adobedice.com/testing/pits/input/smartObjectV2_cc.psd',
            storage: 'external'
        }
    ],
    options: {
        layers: [
            {
                id: 320,
                input: {
                    href: 'https://as2.ftcdn.net/v2/jpg/00/80/88/51/500_F_80885101_vwW81el2bQcXNMnN9mLiNx1wbHjeChrx.jpg',
                    storage: 'external'
                }
            }
        ]
    },
    outputs: [
        {
            storage: 'adobe',
            type: 'image/png',
            overwrite: true,
            width: 300,
            compression: 'small'
        }
    ]
}

module.exports = { Payload, Desc }
